module.exports = __webpack_public_path__ + "static/img/1_2_2.3a1c7ee9.jpg";